import { render } from "./process-workspace.html?vue&type=template&id=276d8712&scoped=true&ts=true"
import script from "./process-workspace.ts?vue&type=script&lang=ts"
export * from "./process-workspace.ts?vue&type=script&lang=ts"

import "./process-workspace.scss?vue&type=style&index=0&id=276d8712&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-276d8712"]])

export default __exports__